
webpack.register(
    'components/alert-manager/alert-manager',
    function() {
        return import('components/alert-manager/alert-manager');
    },
    true
);